<template>
  <div id="notifications-bell">
    <v-menu
      v-model="menuOpened"
      bottom
      left
      offset-y
      origin="top right"
      transition="scale-transition"
      :close-on-content-click="false"
      max-height="400"
      content-class="elevation-1"
    >
      <template v-slot:activator="{ attrs, on }">
        <v-btn small text v-bind="attrs" class="px-0" v-on="on">
          <v-badge v-if="unread" color="softRed" overlap bordered>
            <template v-slot:badge>
              <span>{{ unread }}</span>
            </template>
            <v-icon :color="$vuetify.theme.dark ? 'white' : 'darkTextGrey'">
              mdi-bell-outline
            </v-icon>
          </v-badge>

          <v-icon v-else :color="$vuetify.theme.dark ? 'white' : 'darkTextGrey'">
            mdi-bell-outline
          </v-icon>
        </v-btn>
      </template>

      <v-list id="notifications-bell-list" :tile="false" nav max-width="400" class="pa-0">
        <div v-if="notificationList.length">
          <template v-for="(notification, idx) in notificationList">
            <v-divider v-if="idx > 0" :key="notification.key" />
            <v-list-item
              :key="notification.key"
              class="notifications-bell-list-item pa-3 pr-4 ma-0"
              :class="{ unread: notification.unread }"
              :href="
                notification.metadata && notification.metadata.link
                  ? notification.metadata.link
                  : undefined
              "
              :target="notification.metadata && notification.metadata.link ? '_blank' : undefined"
            >
              <v-list-item-icon class="pa-0 ma-0 mr-4">
                <v-icon
                  v-if="notification.type === 'info'"
                  :color="$vuetify.theme.dark ? 'dark_Textgrey' : 'softTextGrey'"
                  size="24"
                >
                  mdi-information
                </v-icon>
                <v-icon
                  v-if="notification.type === 'upgrade'"
                  :color="$vuetify.theme.dark ? 'dark_Textgrey' : 'softTextGrey'"
                  size="24"
                >
                  mdi-arrow-up-circle
                </v-icon>
                <v-icon
                  v-if="notification.type === 'alert'"
                  :color="$vuetify.theme.dark ? 'dark_Textgrey' : 'softTextGrey'"
                  size="24"
                >
                  mdi-alert
                </v-icon>
              </v-list-item-icon>

              <v-list-item-content class="pa-0 notification-bell-text">
                <template
                  v-if="
                    ['info', 'upgrade', 'alert'].indexOf(notification.type) > -1 &&
                    notification.metadata &&
                    notification.metadata.translationKey
                  "
                >
                  {{
                    $t(
                      `views.core.notifications.translationKeys.${notification.metadata.translationKey}`
                    )
                  }}
                </template>

                <div class="notification-bell-actions items-flex justify-between mt-3">
                  <div class="notification-bell-actions-date">
                    {{ notification.date ? getDateUserFormat(notification.date) : '' }}
                  </div>
                  <div class="items-flex">
                    <div v-if="notification.unread">
                      <a class="primary--text" @click.prevent="markAsRead(idx)">
                        {{ $t(`views.core.notifications.markAsRead`) }}
                      </a>
                    </div>
                    <div v-if="notification.unread" class="mx-2">
                      |
                    </div>
                    <div>
                      <a class="primary--text" @click.prevent="deleteNotification(idx)">
                        {{ $t(`views.core.notifications.deleteNotification`) }}
                      </a>
                    </div>
                  </div>
                </div>
              </v-list-item-content>
            </v-list-item>
          </template>
        </div>
        <div v-else class="no-notifications pa-5">
          {{ $t(`views.core.notifications.noNotifications`) }}
        </div>
      </v-list>
    </v-menu>
  </div>
</template>

<script>
import { get } from 'lodash'
import { mapState, mapActions } from 'vuex'
import { updateUser } from '@/lib/api.js'
import { getDateUserFormat } from '@/lib/utils/date.js'

export default {
  data: () => ({
    menuOpened: null,
  }),
  computed: {
    ...mapState(['user']),
    notificationList() {
      return get(this.user, 'notifications.list', [])
    },
    unread() {
      return this.notificationList.reduce((acc, item) => {
        if (item.unread) acc++
        return acc
      }, 0)
    },
  },
  methods: {
    ...mapActions({ updateUsersInfo: 'UPDATE_USERS_INFO' }),
    getDateUserFormat,
    async updateUserNotifications(notifications) {
      try {
        const data = {
          notifications,
        }
        await updateUser({ uid: this.user.uid, data })
        await this.updateUsersInfo()
      } catch (error) {
        this.$root.$snackbar.error({ text: this.$t('common.commonError') })
      }
    },
    async markAsRead(idx) {
      const notifications = JSON.parse(JSON.stringify(this.user.notifications))
      delete notifications.list[idx].unread
      await this.updateUserNotifications(notifications)
    },
    async deleteNotification(idx) {
      const notifications = JSON.parse(JSON.stringify(this.user.notifications))
      notifications.list.splice(idx, 1)
      await this.updateUserNotifications(notifications)
    },
  },
}
</script>

<style lang="scss">
#notifications-bell-list {
  .items-flex {
    display: flex;
    &.justify-between {
      justify-content: space-between;
    }
  }

  .no-notifications {
    width: 100%;
    text-align: center;
    font-size: 13px;
  }

  .notifications-bell-list-item {
    background: white;
    &.unread {
      background: #f7f8fb;
    }

    .notification-bell-text {
      font-size: 13px;
    }
    .notification-bell-actions {
      font-size: 12px;
      a {
        text-decoration: none;
      }
      .notification-bell-actions-date {
        color: #636363;
      }
    }
  }
  .notifications-bell-list-item.theme--dark {
    background: #292929;
    &.unread {
      background: #323940;
    }
    .notification-bell-actions {
      .notification-bell-actions-date {
        color: #a5a5a5;
      }
    }
  }
}
</style>
